import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { reusableFetch, reusableFormDataFetch } from "../../utils/useAxios";

export const getAnnouncementPosts = createAsyncThunk("announcementPost/getAnnouncementPosts", async (data, { rejectWithValue }) => {
  const announcementPost = await reusableFetch(`announcement-post/all`, "POST", data, rejectWithValue);
  return announcementPost;
});

export const getAnnouncementPostById = createAsyncThunk("announcementPost/getAnnouncementPostById", async ({ announcementPostId }, { rejectWithValue }) => {
  const announcementPost = await reusableFetch(`announcement-post/${announcementPostId}`, "GET", {}, rejectWithValue);
  return announcementPost;
});

export const startAnnouncementPost = createAsyncThunk("announcementPost/startAnnouncementPost", async (data, { rejectWithValue }) => {
  const announcementPost = await reusableFetch(`announcement-post/`, "POST", data, rejectWithValue);
  return announcementPost;
});

export const updateAnnouncementPost = createAsyncThunk("announcementPost/updateAnnouncementPost", async (data, { rejectWithValue }) => {
  const announcementPost = await reusableFetch(`announcement-post/${data.announcementPostId}`, "PUT", data, rejectWithValue);
  return announcementPost;
});

export const updateAnnouncementPostStatus = createAsyncThunk("announcementPost/updateAnnouncementPostStatus", async ({ announcementPostId, status }, { rejectWithValue }) => {
  const announcementPost = await reusableFetch(`announcement-post/status/${announcementPostId}`, "PATCH", { status }, rejectWithValue);
  return announcementPost;
});


export const saveAnnouncementPostImage = createAsyncThunk(
  "announcementPost/saveAnnouncementPostImage",
  async ({ formData }, { rejectWithValue }) => {
    const announcementPost = await reusableFormDataFetch(
      `announcement-post/upload`,
      "POST",
      formData,
      rejectWithValue,
      false,
    );
    return announcementPost;
  },
);


const initialState = {
  announcementPosts: null, // List
  announcementPost: null,
  isGettingAnnouncementPost: false,
  isGettingAnnouncementPostData: false,
  isUploadingAnnouncementPostImage: false,
  isAnnouncementPostStatusUpdating: false,
  isAnnouncementPostStarting: false,
  isUpdatingAnnouncementPost: false,
  updatingAnnouncementPostId: false,
};

export const announcementPostSlice = createSlice({
  name: "announcementPost",
  initialState,
  reducers: {
    saveAnnouncementPostValue: (state, action) => _.merge(state, action.payload),
    clearAnnouncementPostState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAnnouncementPosts.pending, (state, { payload }) => {
        state.isGettingAnnouncementPostData = true;
      })
      .addCase(getAnnouncementPosts.fulfilled, (state, { payload }) => {
        state.isGettingAnnouncementPostData = false;
        state.announcementPosts = payload?.data?.data?.getAllAnnouncementPostData || null;
      })
      .addCase(getAnnouncementPosts.rejected, (state, { payload }) => {
        state.isGettingAnnouncementPostData = false;
      })
      .addCase(getAnnouncementPostById.pending, (state, { payload }) => {
        state.isGettingAnnouncementPostData = true;
      })
      .addCase(getAnnouncementPostById.fulfilled, (state, { payload }) => {
        state.isGettingAnnouncementPostData = false;
        state.announcementPost = payload?.data?.data;
      })
      .addCase(getAnnouncementPostById.rejected, (state, { payload }) => {
        state.isGettingAnnouncementPostData = false;
      })
      .addCase(startAnnouncementPost.pending, (state, { payload }) => {
        state.isAnnouncementPostStarting = true;
      })
      .addCase(startAnnouncementPost.fulfilled, (state, { payload }) => {
        state.isAnnouncementPostStarting = false;
        state.announcementPost = payload?.data?.data?.announcementPost;
      })
      .addCase(saveAnnouncementPostImage.pending, (state) => {
        state.isUploadingAnnouncementPostImage = true;
      })
      .addCase(saveAnnouncementPostImage.fulfilled, (state, { payload }) => {
        state.isUploadingAnnouncementPostImage = false;
        state.announcementPost = payload?.data?.data;
      })
      .addCase(saveAnnouncementPostImage.rejected, (state) => {
        state.isUploadingAnnouncementPostImage = false;
      })
      .addCase(startAnnouncementPost.rejected, (state, { payload }) => {
        state.isAnnouncementPostStarting = false;
      })
      .addCase(updateAnnouncementPost.pending, (state, { payload }) => {
        state.isUpdatingAnnouncementPost = true;
      })
      .addCase(updateAnnouncementPost.fulfilled, (state, { payload }) => {
        state.isUpdatingAnnouncementPost = false;
      })
      .addCase(updateAnnouncementPost.rejected, (state, { payload }) => {
        state.isUpdatingAnnouncementPost = false;
      })
      .addCase(updateAnnouncementPostStatus.pending, (state, { payload }) => {
        state.isAnnouncementPostStatusUpdating = true;
      })
      .addCase(updateAnnouncementPostStatus.fulfilled, (state, { payload }) => {
        state.isAnnouncementPostStatusUpdating = false;
        state.announcementPost.status = payload?.data?.data?.status;
      })
      .addCase(updateAnnouncementPostStatus.rejected, (state, { payload }) => {
        state.isAnnouncementPostStatusUpdating = false;
      })
  },
});

export const {
  saveAnnouncementPostValue,
  clearAnnouncementPostState,
} = announcementPostSlice.actions;

export const announcementPostSelector = (state) => state.announcementPost;
